import { render, staticRenderFns } from "./inbound-email-failed-icon.vue?vue&type=template&id=7c457ef6"
import script from "./inbound-email-failed-icon.vue?vue&type=script&lang=js"
export * from "./inbound-email-failed-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c457ef6')) {
      api.createRecord('7c457ef6', component.options)
    } else {
      api.reload('7c457ef6', component.options)
    }
    module.hot.accept("./inbound-email-failed-icon.vue?vue&type=template&id=7c457ef6", function () {
      api.rerender('7c457ef6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/contact-activity/inbound-email-failed-icon.vue"
export default component.exports